export function updateInterviewMapper(request) {
  return {
    page: {
      data: request.data,
      name: request.pageName,
    },
  };
}
